"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.visitJSONReferences = exports.isJSONReference = void 0;
var visitObjects_1 = require("./visitObjects");
function isJSONReference(value) {
    return typeof value === 'object' && '$ref' in value;
}
exports.isJSONReference = isJSONReference;
function visitJSONReferences(value, initialState, visitor) {
    var states = [initialState];
    (0, visitObjects_1.visitObjects)(value, function (object, location, visitChildren) {
        if (isJSONReference(object)) {
            if (typeof object.$ref === 'string') {
                var newState = __assign({}, states[states.length - 1]);
                states.push(newState);
                visitor(object, location, newState);
                states.pop();
            }
        }
        else {
            visitChildren();
        }
    });
}
exports.visitJSONReferences = visitJSONReferences;
